<template>
  <v-dialog v-model="showModal" max-width="500px" persistent>    
    <v-card>      
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="showModal = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>                    
        </v-toolbar>                
        <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>          
        <v-form :class="visibility_class" @submit="handleSubmit">
          <v-container  grid-list-xl>
            <v-layout row wrap>
            <v-flex xs12>
              <v-text-field label="Nazwa*" v-validate="'required'" name="name" id="name" :error-messages="errors.collect('name')" data-vv-as="Nazwa" v-model="name"></v-text-field>                 
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Opis" name="description" id="description"   v-model="description"></v-text-field>
            </v-flex>
              <v-flex xs12 v-if="placowki && placowki.length > 0">
                <v-select label="Placówka" :items="placowki" return-object item-text="name" v-model="wybranaPlacowka"></v-select>
              </v-flex>
            </v-layout>
            <v-row>
              <v-col cols="12">
                <label for="color">Przypisany kolor:</label>
                <ColorPicker :color="Color" v-model="Color" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        </v-card-text>
        <v-card-actions>
           <v-spacer></v-spacer>
          <v-btn @click="closeForm" color="error">Zamknij</v-btn>
          <v-btn color="success"   @click="handleSubmit">Zapisz</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { roomService } from "@/services/";
import swal from "sweetalert";
import ColorPicker from "@/components/shared/ColorPicker.vue";
export default {
  name: "AddEditRole",
  components: {ColorPicker},
  data() {
    return {
      title: "Dodawanie nowego gabinetu",
      loading: false,
      name: null,
      description: null,
      is_super_admin_role: false,
      is_static: false,
      visibility_class: 'row',
      perms: [],
      Color: '0',
      wybranaPlacowka: null
    };
  },
  props: ["id","visible", "placowki"],
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    closeForm() {
      this.$emit("close");
    },
    handleSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.saveRoom();
        }
      });
    },
    saveRoom() {      

      this.hide()
      if (this.id === undefined || this.id == 0) {
        
        roomService
          .create({
            name: this.name,
            description: this.description,
            placowkaId : this.wybranaPlacowka ? this.wybranaPlacowka.id : 0,
            color: this.Color
          })
          .then(() => {
            this.show()
            this.$emit("close");
          })
          .catch(e => {
            this.showError(false, "Błąd zapisu gabinetu.");
            console.log(e);
            this.show()
          });
      } else {
        roomService
          .update({
            name: this.name,            
            description: this.description,            
            id: this.id,
            placowkaId : this.wybranaPlacowka ? this.wybranaPlacowka.id : 0,
            color: this.Color
          })
          .then(() => {            
            this.show()
            this.$emit("close");
          })
          .catch(e => {
            console.log(e);
            this.showError(false, "Nie mozna zaktualizowac gabinetu.");
            this.show()
          });
      }
    },
    loadRoomData()
    {
      
      if(this.id != 0)
      {
        this.loading = true;        
        roomService.get(this.id).then(resp => {            
            if (resp.data != null && resp.data.success && resp.data.result != null) {
                        
                this.name = resp.data.result.name
                this.description = resp.data.result.description
                this.Color = resp.data.result.color
                this.wybranaPlacowka = this.placowki.find(x=>x.id == resp.data.result.placowkaId)
                this.loading = false;    
                this.title = "Edycja gabinetu: "+this.name
            } else {
                throw "Error: " + resp.data.error;
            }
            }).catch(e => {
            console.log(e);
            this.showError(true, "Nie można pobrać informacji o gabinecie.");
            this.loading = false;
            });
      }
    },
    hide() {
        this.visibility_class = 'row scale-transition scale-out'
        this.loading = true
    },
    show() {
        this.visibility_class = 'row'
        this.loading = false
    },
    clearFormData() {
      this.name = null
      this.description = null
      this.title = "Dodawanie nowego gabinetu"
    }    
  },  
  created(){
      this.loadRoomData();
  },
  computed: {
    showModal: {
      get: function() {
        if(!this.visible)
        {
          this.clearFormData()
          this.errors.clear();
        }
        return this.visible
      },
      set: function(value) {                
        if(!value){
          this.$emit('close')
        }

      }
    }
  },
  watch: {
    id: function(newId)
    {

      if(newId > 0)
      {
        this.loading = true
        this.loadRoomData()
      }
      else
      {
          this.clearFormData()
          this.errors.clear();
      }

    }
  },    
};
</script>

<style>

</style>
